import { render, staticRenderFns } from "./SpreadSheetTemplate.vue?vue&type=template&id=7c20f64c&scoped=true&"
import script from "./SpreadSheetTemplate.vue?vue&type=script&lang=js&"
export * from "./SpreadSheetTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SpreadSheetTemplate.vue?vue&type=style&index=0&id=7c20f64c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c20f64c",
  null
  
)

export default component.exports